<script lang="ts" setup>
import { ref, onMounted } from "vue";
import ProductFlashOffer from "@/components/home/ProductFlashOffer.vue";
import ProductFlashOfferFirst from "@/components/home/ProductFlashOfferFirst.vue";
import { HomeService } from "@/services/HomeService";
import { Swiper, SwiperSlide } from "swiper/vue";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
  FreeMode,
} from "swiper/modules";
import { Jsona } from "jsona";
import Product from "@/models/Product";
import { useIntersectionObserver } from "@vueuse/core";

const dataFormatter = new Jsona();

const modules = [Pagination, Scrollbar, A11y, Navigation, EffectFade, FreeMode];
const products = ref<Product[]>([]);
const homeService = ref<HomeService | null>(null);
const page = ref(1);
const clicks = ref(0);
const seeMore = ref("/");
const loading = ref(false);

onMounted(() => {
  //
});

const getMoreProducts = () => {
  if (clicks.value === 0 && homeService.value) {
    clicks.value++;
    homeService.value.getFlashProducts(page.value).then((response) => {
      if (response) {
        const newProducts = dataFormatter.deserialize(response);
        products.value = products.value.concat(newProducts.splice(0, 4));
        page.value++;
      }
    });
  } else {
    const path = "/buscar/oferta_relampago";
    window.location.href = path;
  }
};

const search = () => {
  loading.value = true;
  homeService.value = new HomeService();
  homeService.value.getFlashProducts(null).then((response) => {
    if (response) {
      products.value = dataFormatter.deserialize(response) as Product[];
      seeMore.value = response.links?.self || "/";
      page.value++;
      loading.value = false;
    }
  });
};

const section = ref<HTMLElement>();
let searched = false;
useIntersectionObserver(section, ([observer]) => {
  if (!searched && observer.isIntersecting) {
    searched = true;
    search();
  }
});
</script>
<template>
  <section ref="section">
    <div
      v-if="products.length > 0"
      class="mt-4 mt-lg-5 px-3 px-lg-0 flash-deals"
    >
      <h2 class="text-secondary title">Ofertas relámpago</h2>
      <div
        v-if="!loading"
        class="row row-cols-2 row-cols-lg-3 row-cols-xl-4 row-gap-3 mt-3 d-none d-lg-flex"
      >
        <div
          v-for="(product, index) in products"
          :key="index"
          class="col px-1 px-lg-2"
        >
          <product-flash-offer-first v-if="index == 0" :product="product" />
          <product-flash-offer v-if="index > 0" :product="product" />
        </div>
      </div>
      <div v-if="!loading" class="mt-3 d-block d-lg-none">
        <swiper
          :modules="modules"
          :navigation="false"
          :loop="false"
          :pagination="false"
          :slides-per-view="2"
          :space-between="5"
          :scrollbar="{ draggable: true }"
          :free-mode="true"
          class="p-0"
        >
          <swiper-slide v-for="(product, index) in products" :key="index">
            <product-flash-offer-first v-if="index == 0" :product="product" />
            <product-flash-offer v-if="index > 0" :product="product" />
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-if="loading"
        class="d-flex justify-content-center align-content-center p-2"
      >
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden mx-auto">Loading...</span>
        </div>
      </div>
      <div class="row px-2 mt-3 d-none d-lg-block">
        <button
          class="w-100 bg-body-tertiary border-0 fs-5 text-primary p-3"
          @click="getMoreProducts"
        >
          Ver más resultados
        </button>
      </div>
    </div>
  </section>
</template>
<style lang="sass"></style>
